module.exports = "/images/vendor/leaflet-fullscreen/dist/fullscreen@2x.png?473ee081160a469c95199d70e78f55fa";